var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import languageProviderReducer from '@project/containers/LanguageProvider/reducer';
import rootReducer from '@project/containers/Root/reducer';
import permissionsReducer from './permissions/reducer';
import platformReducer from './platform/reducer';
import mediaReducer from './media/reducer';
import buildReducer from './builds/reducer';
import columnReducer from './columns/reducer';
import signupReducer from './signup/reducer';
import configureAccountReducer from './configureAccount/reducer';
import introModalReducer from './introductionModal/reducer';
import apikeyStateReducer from './apikey/reducer';
import viewBuilderReducer from '@project/containers/ViewBuilder/LegacyViewBuilder/reducer';
import colourPreviewReducer from '@project/containers/SelectPreview/ColourPreview/reducer';
import typographyPreviewReducer from '@project/containers/SelectPreview/ColourPreview/reducer';
import stateReducer from './state/reducer';
import environmentsReducer from './environment/reducer';
import variablesReducer from './variable/reducer';
import globalStorageReducer from './storage/reducer';
import datasetRulesReducer from './rules/reducer';
import { publishConfigReducer } from './publishConfig/reducer';
import logicBuilderReducer from './logicBuilder/reducer';
import selectedAppReducer from './selectedApp/reducer';
import resellerReducer from './reseller/reducer';
import globalSearchReducer from './globalSearch/reducer';
import createAppFlowReducer from './createAppFlow/reducer';
import ManagedOrgDeveloperPlanReducer from './resellerSelectedManagedOrgDevPlan/reducer';
import appDevPlanStatusReducer from './appDevPlanStatus/reducer';
import OrgDeveloperPlanReducer from './orgDevPlan/reducer';
import appSettingsReducer from './appSettings/reducer';
import versionsReducer from '@project/containers/Versions/reducer';
import versionNewReducer from './versionNew/reducer';
import appAdminsReducer from '../containers/AppAdmins/reducer';
import groupsReducer from '../containers/Admins/reducer';
import pushNotificationsReducer from './pushNotifications/reducer';
import analyticsReducer from './analytics/reducer';
import usersReducer from './users/reducer';
import userInviteReducer from './userInvite/reducer';
import newPasswordPageReducer from './newPassword/reducer';
import appUserGroupsReducer from './appUserGroups/reducer';
import userEditReducer from './appUserEdit/reducer';
import userNewReducer from './userImportNew/reducer';
import templateReducer from './template/reducer';
import datasetRowReducer from './datasetRow/reducer';
import datasetEditReducer from './datasetEdit/reducer';
import orgStatusSummeryReducer from './orgStatusSummery/reducer';
import pushTemplateStateReducer from './pushTemplates/reducer';
import integrationReducer from './integration/reducer';
import integrationNewReducer from './integrationNew/reducer';
import methodNewReducer from './integrationMethodCreate/reducer';
import pushMultiAppsReducer from './pushMultiApps/reducer';
import usersSharedAppsReducer from './usersSharedApps/reducer';
export var history = createBrowserHistory();
/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */
/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
    if (injectedReducers === void 0) { injectedReducers = {}; }
    return combineReducers(__assign({ router: connectRouter(history), language: languageProviderReducer, root: rootReducer, permissions: permissionsReducer, platform: platformReducer, media: mediaReducer, build: buildReducer, columns: columnReducer, signup: signupReducer, configureAccount: configureAccountReducer, introModal: introModalReducer, apikeyState: apikeyStateReducer, viewBuilder: viewBuilderReducer, colourPreview: colourPreviewReducer, typographyPreview: typographyPreviewReducer, template: templateReducer, states: stateReducer, environments: environmentsReducer, variables: variablesReducer, storage: globalStorageReducer, datasetRules: datasetRulesReducer, publishConfig: publishConfigReducer, selectedApp: selectedAppReducer, reseller: resellerReducer, globalSearch: globalSearchReducer, logicBuilder: logicBuilderReducer, managedOrgDevPlan: ManagedOrgDeveloperPlanReducer, appDevPlanStatus: appDevPlanStatusReducer, orgDevPlans: OrgDeveloperPlanReducer, appSettings: appSettingsReducer, appCreationFlow: createAppFlowReducer, versions: versionsReducer, versionNew: versionNewReducer, appAdmins: appAdminsReducer, groups: groupsReducer, pushNotifications: pushNotificationsReducer, analytics: analyticsReducer, users: usersReducer, datasetEdit: datasetEditReducer, datasetRow: datasetRowReducer, userInvite: userInviteReducer, newPasswordPage: newPasswordPageReducer, appUserGroups: appUserGroupsReducer, userEdit: userEditReducer, userNew: userNewReducer, orgStatusSummery: orgStatusSummeryReducer, pushTemplateState: pushTemplateStateReducer, integration: integrationReducer, integrationNew: integrationNewReducer, methodNew: methodNewReducer, pushMultiApps: pushMultiAppsReducer, sharedUsersManagement: usersSharedAppsReducer }, injectedReducers));
}
